import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { Verification } from 'dashboard/models/verification';
import Sticker from 'design-system/components/Sticker';
import { assertNever } from 'lib/utils/types';
import { VerificationStatus } from 'lib/verification';

const StickerContainer = styled('div')`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;

  grid-column-gap: ${Spacing[2]};
  grid-row-gap: ${Spacing[2]};
`;

interface VerificationStatusStickerProps {
  verification: Verification;
}

const VerificationStatusSticker = ({ verification }: VerificationStatusStickerProps) => {
  switch (verification.attributes.status) {
    case VerificationStatus.Initiated: {
      return (
        <StickerContainer>
          <Sticker variant='basic'>Initiated</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Confirmed: {
      // Only for phone verification when code is entered. Similar to 'submitted'.
      return (
        <StickerContainer>
          <Sticker variant='caution'>Confirmed</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Submitted: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Submitted</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.TentativelyPassed: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Tentatively Passed</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.TentativelyFailed: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Tentatively Failed</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Passed: {
      return (
        <StickerContainer>
          <Sticker variant='success'>Passed</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.RequiresRetry: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Requires Retry</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Failed: {
      return (
        <StickerContainer>
          <Sticker variant='danger'>Failed</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Skipped: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Skipped</Sticker>
        </StickerContainer>
      );
    }
    case VerificationStatus.Canceled: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Canceled</Sticker>
        </StickerContainer>
      );
    }
    default:
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      return assertNever(verification.attributes.status);
  }
};

export default VerificationStatusSticker;
